import { useEffect, useState } from "react";
import { MoonStar } from "lucide-react";
import { waLink } from "@/lib/site";
import { useLang } from "@/i18n";

const LINKS = [
    { href: "/#inicio", key: "nav.inicio", testid: "nav-link-inicio" },
    { href: "/#servicios", key: "nav.servicios", testid: "nav-link-servicios" },
    { href: "/#productos", key: "nav.productos", testid: "nav-link-productos" },
    { href: "/#velas", key: "nav.velas", testid: "nav-link-velas" },
    { href: "/#nosotros", key: "nav.nosotros", testid: "nav-link-nosotros" },
    { href: "/#ubicacion", key: "nav.ubicacion", testid: "nav-link-ubicacion" },
    { href: "/#contacto", key: "nav.contacto", testid: "nav-link-contacto" },
];

const LangSwitcher = () => {
    const { lang, setLang } = useLang();
    return (
        <div className="flex items-center border border-gold/35 rounded-sm overflow-hidden" data-testid="lang-switcher">
            {["es", "en"].map((l) => (
                <button
                    key={l}
                    onClick={() => setLang(l)}
                    data-testid={`lang-switch-${l}`}
                    aria-pressed={lang === l}
                    className={`px-2.5 py-1.5 font-accent text-[10px] tracking-[0.15em] uppercase transition-colors duration-300 ${
                        lang === l ? "bg-gold text-ink font-bold" : "text-gold-soft hover:text-gold"
                    }`}
                >
                    {l}
                </button>
            ))}
        </div>
    );
};

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const { t } = useLang();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
                scrolled
                    ? "bg-ink/85 backdrop-blur-xl border-b border-gold/15"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8 flex items-center justify-between h-16 sm:h-[4.5rem]">
                <a href="/#inicio" data-testid="nav-logo-link" className="flex items-center gap-2.5 group">
                    <MoonStar className="w-5 h-5 text-gold transition-transform duration-500 group-hover:rotate-12" />
                    <span className="font-display text-lg sm:text-xl tracking-wide gold-text font-semibold">
                        Jardin D'Venuz
                    </span>
                </a>
                <nav className="hidden lg:flex items-center gap-7" aria-label="Navegación principal">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={l.testid}
                            className="font-accent text-[11px] tracking-[0.2em] uppercase text-cream/70 hover:text-gold transition-colors duration-300"
                        >
                            {t(l.key)}
                        </a>
                    ))}
                </nav>
                <div className="flex items-center gap-3">
                    <LangSwitcher />
                    <a
                        href={waLink(t("wa.appointment"))}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="nav-cta-button"
                        className="hidden sm:inline-flex items-center border border-gold/60 text-gold font-accent text-[11px] tracking-[0.18em] uppercase px-5 py-2.5 rounded-sm hover:bg-gold/10 hover:shadow-[0_0_20px_rgba(212,175,55,0.2)] transition-[background-color,box-shadow] duration-300"
                    >
                        {t("nav.cta")}
                    </a>
                </div>
            </div>
        </header>
    );
};
